import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=34b5458c"
import script from "./FileDrop.vue?vue&type=script&lang=js"
export * from "./FileDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=34b5458c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports